import type { TOrderType } from 'app/helpers/parseQueryParamOrder';

export type TOrganizationJobsListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: TOrderType;
  search: string;
  statuses: string;
  jobsFrom: string;
  jobsTo: string;
};

export type TWorkspaceJobsListTab = 'all' | 'assigned';

type TWorkspaceJobsListBaseParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: TOrderType;
  search: string;
  from: string;
  to: string;
};

export type TWorkspaceJobsListParams =
  | (TWorkspaceJobsListBaseParams & { tab: 'all'; status: string })
  | (TWorkspaceJobsListBaseParams & { tab: 'assigned' });

export type TRepositoryJobsListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: TOrderType;
  search: string;
};

export const jobsKeys = {
  all: [{ module: 'jobs' }] as const,
  lists: () => [{ ...jobsKeys.all[0], scope: 'list' }] as const,
  listsByOrg: (organizationId: string) => [{ ...jobsKeys.lists()[0], organizationId }] as const,
  orgList: (organizationId: string, params: TOrganizationJobsListParams) =>
    [{ ...jobsKeys.listsByOrg(organizationId)[0], params }] as const,
  listsByWorkspace: (workspaceId: string) => [{ ...jobsKeys.lists()[0], workspaceId }] as const,
  workspaceList: (workspaceId: string, params: TWorkspaceJobsListParams) =>
    [{ ...jobsKeys.listsByWorkspace(workspaceId)[0], params }] as const,
  listsByRepository: (repositoryId: string) => [{ ...jobsKeys.lists()[0], repositoryId }] as const,
  repositoryList: (repositoryId: string, params: TRepositoryJobsListParams) =>
    [{ ...jobsKeys.listsByRepository(repositoryId)[0], params }] as const,
  details: () => [{ ...jobsKeys.all[0], scope: 'detail' }] as const,
  detail: (jobId: string) => [{ ...jobsKeys.details()[0], jobId }] as const,
  workspaceDetail: (jobId: string, workspaceId: string) => [{ ...jobsKeys.detail(jobId)[0], workspaceId }] as const,
  partialUnlockedFiles: () => [{ ...jobsKeys.all[0], scope: 'partialUnlockedFiles' }] as const,
  partialUnlockedFilesByJob: (jobId: string) => [{ ...jobsKeys.partialUnlockedFiles()[0], jobId }] as const,
  playbackAudioUrls: () => [{ ...jobsKeys.all[0], scope: 'playbackAudioUrl' }] as const,
  playbackAudioUrl: (jobId: string, file: string) => [{ ...jobsKeys.playbackAudioUrls()[0], jobId, file }] as const,
  attachments: () => [{ ...jobsKeys.all[0], scope: 'attachment' }] as const,
  attachment: (jobId: string, workspaceId: string, attachmentId: string) =>
    [{ ...jobsKeys.attachments()[0], jobId, workspaceId, attachmentId }] as const,
  lockedStatuses: () => [{ ...jobsKeys.all[0], scope: 'lockedStatus' }] as const,
  lockedStatusByRecordingId: (recordingId: string) => [{ ...jobsKeys.lockedStatuses()[0], recordingId }] as const,
  lockedStatusByJobId: (jobId: string) => [{ ...jobsKeys.lockedStatuses()[0], jobId }] as const,
};
